




































import { Component, Vue, Prop } from 'vue-property-decorator'
import { denyPayments } from '@/services/payments'
import { Payment } from '@/types/Payments'

@Component
export default class DenyPaymentsDialog extends Vue {

  @Prop({ default: false }) opened!: boolean
  @Prop({ default: [] }) paymentIds!: Array<number>
  
  get payments() {
    return this.$store.getters.paymentsByIds(this.paymentIds)
  }

  get countUniquePeople() {
    return this.payments.reduce((acc: any[], payment: Payment) => {
      if (acc.indexOf(payment.receiver.id) === -1) {
        acc.push(payment.receiver.id)
      }
      return acc
    }, []).length
  }

  loading = false
  
  closeDialog() {
    this.$emit("update:opened", false)
  }

  async denyPayments() {
    this.loading = true
    try {
      await denyPayments(this.$store, this.paymentIds)
      this.closeDialog()
      this.$emit('denied')
    }
    finally {
      this.loading = false
    }
  }
}
